import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Acción para obtener los datos del suelo de un nodo
export const sueloNodo = createAsyncThunk(
    'sueloNodo/getSueloNodo',
    async ({ lat, lon }) => {
        try {
            const response = await axios.get("/api/sensor/getSueloNodo", {
                params: {
                    lat,
                    lon
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);